const logo = window.STATIC_PATH + 'images/logo.png';
const fvsLogo = window.STATIC_PATH + 'images/fvs/logo.png';

export const getBrandingOptions = () => {
  const hostname = window.location.hostname;
  let logoUrl = logo;
  let monoAuthUrl = window.MONO_AUTH_FRONTEND_URL;
  let whiteLabel = null;
  switch (hostname) {
      case 'fvs.emiot.com.au':
          logoUrl = fvsLogo;
          monoAuthUrl = 'https://fvs-account.wbstech.com.au/';
          whiteLabel = 'FVS';
          break;
      case 'fvs-staging.emiot.com.au':
          logoUrl = fvsLogo;
          monoAuthUrl = 'https://fvs-account-staging.wbstech.com.au/';
          whiteLabel = 'FVS';
          break;
      default:
          break;
  }

  function constructMonoAuthSignInUrl(redirectPathParam) {
      const redirectPath = redirectPathParam != null ? redirectPathParam : encodeURIComponent('/');
      return `${monoAuthUrl}sign-in?brand=EMIOT&redirectPath=${redirectPath}`;
  }
  function constructMonoAuthProfileUrl() {
      const redirectPath = encodeURIComponent(`${window.location.pathname}${window.location.search}`);
      return `${monoAuthUrl}dashboard/profile?brand=EMIOT&redirectPath=${redirectPath}`;
  }
    function constructMonoAuthLogoutUrl() {
        // Including redirectPath means that if the user logs in again, they will be redirected to EMIoT after login,
        // rather than being taken to mono-auth dashboard.
        return `${monoAuthUrl}logout?brand=EMIOT&redirectPath=${encodeURIComponent('/')}`;
    }

  const brandingOptions = {
      whiteLabel,
      logoUrl,
      constructMonoAuthSignInUrl,
      constructMonoAuthProfileUrl,
      constructMonoAuthLogoutUrl,
  };
  return brandingOptions;
}